import { render, staticRenderFns } from "./MemberBookings.vue?vue&type=template&id=56caa513"
import script from "./MemberBookings.vue?vue&type=script&lang=js"
export * from "./MemberBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports